/* eslint-disable no-unused-vars */
import {API_URL} from '../constants/index.js';
import {
    ITEM,
    ITEM_SUCCESS,
    ITEM_ERROR,
    ADD_ITEM,
    ADD_ITEM_SUCCESS,
    ADD_ITEM_ERROR,
    UPDATE_ITEM,
    UPDATE_ITEM_SUCCESS,
    UPDATE_ITEM_ERROR,
    DELETE_ITEM,
    DELETE_ITEM_ERROR,
    DELETE_ITEM_SUCCESS,
    ITEMICON,
    ITEMICON_SUCCESS,
    ITEMICON_ERROR,
    ITEM_DATE,
    ITEM_DATE_SUCCESS,
    ITEM_DATE_ERROR
} from '../constants/itemConstant.js';

import {sweetAlert} from '../components/Alert/sweetAlert'


// 03/26/20
import ky from '../components/AuthEngine';
// 03/26/20



//#region ITEM (ALL - BYID)
export function getitem(data) {
    return {
        type: ITEM,
        data
    }
}

export function getitemSuccess(data) {
    return {
        type: ITEM_SUCCESS,
        data
    }
}

export function getitemError(data) {
    return {
        type: ITEM_ERROR,
        data
    }
}

export function getAllItems(data) {
    return dispatch => {
        dispatch(getitem());
        fetch(API_URL+'items/items',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                 }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getitemSuccess(res));;
                return res;
            })
            .catch(error => {
                dispatch(getitemError(error));
            })
    }
}

export function getItemById(id) {
    return dispatch => {
        dispatch(getitem());
        fetch(API_URL+'items/items/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                 }
            })
            .then(res => res.json())
            .then(res => {
                if(res.ok)
                    dispatch(getitemSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getitemError(error));
            })
    }
}

export function getItemsByCommunity(communityId, sort) {
    return dispatch => {
        dispatch(getitem());
        fetch(API_URL+'items/itemsbycommunityid/' + communityId,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'sort': sort === true ? 1 : -1
                 }
            })
            .then(res => res.json())
            .then(res => {
                if(Array.isArray(res)){
                    dispatch(getitemSuccess(res));
                    return res;
                }else{
                    dispatch(getitemSuccess([]));
                }
              
            })
            .catch(error => {
                dispatch(getitemError(error));
            })
    }
}

//#endregion


//#region ADD ITEM

    export function newitem(data) {
        return {
            type: ADD_ITEM,
            data
        }
    }

    export function newitemSuccess(data) {
        return {
            type: ADD_ITEM_SUCCESS,
            data
        }
    }

    export function newitemError(data) {
        return {
            type: ADD_ITEM_ERROR,
            data
        }
    }

    export function addItem(data) {
        return dispatch => {
            dispatch(newitem());
            fetch(API_URL+'items/items',
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                     }
                })
                .then(res => {
                    dispatch(newitemSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The element ${data.name} has been added successfully`

                    sweetAlert('success',message,'alert_AddItem_Success');
                })
                .catch(error => {
                    dispatch(newitemError(error));
                    const message = `An error occurred trying to add the item ${data.name} `

                    sweetAlert('error',message,'alert_AddItem_Error');
                })
        }
    }

    export function addItemByCommunity(data, communityId, objStyles) {
        return dispatch => {
            dispatch(newitem());
            fetch(API_URL+'/items/additembycommunityid/'+communityId,
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                     }
                })
                .then(res => res.json())
                .then(res => {
                    dispatch(newitemSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The element ${data.name} has been added successfully`

                    sweetAlert('success',message,'alert_AddItemByCommunity_Success', objStyles);
                })
                .catch(error => {
                    dispatch(newitemError(error));
                    const message = `An error occurred when trying to add the item ${data.name} `

                    sweetAlert('error',message,'alert_AddItemByCommunity_Error', objStyles);
                })
        }
    }

//#endregion

//#region UPDATE ITEM

    export function modItem(data) {
        return {
            type: UPDATE_ITEM,
            data
        }
    }

    export function modItemSuccess(data) {
        return {
            type: UPDATE_ITEM_SUCCESS,
            data
        }
    }

    export function modItemError(data) {
        return {
            type: UPDATE_ITEM_ERROR,
            data
        }
    }

    export function updItem(id, data, objStyles) {
        return dispatch => {
            dispatch(modItem());
            fetch(API_URL+'items/items/'+ id,
                {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                     }
                })
                .then(res => {
                    dispatch(modItemSuccess(data));

                    return res;
                })
                .then( () =>{

                    const message = `The element ${data.name} has been updated successfully`

                    sweetAlert('success',message,'alert_UpdateItem_Success', objStyles);
                })
                .catch(error => {
                    dispatch(modItemError(error));

                    const message = `An error occurred when trying to update the item ${data.name} `

                    sweetAlert('error',message,'alert_UpdateItem_Error', objStyles);
                })
        }
    }

//#endregion


//#region DELETE ISSUE

export function deleteItem(data) {
    return {
        type: DELETE_ITEM,
        data
    }
}

export function deleteItemSuccess(data) {
  
    return {
        type: DELETE_ITEM_SUCCESS,
        data
    }
}

export function deleteItemError(data) {
    return {
        type: DELETE_ITEM_ERROR,
        data
    }
}

export function delItem(id, data) {
    return dispatch => {
        
        dispatch(deleteItem());
        
        fetch(API_URL+'items/items/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deleteItemSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The element has been deleted successfully`

                sweetAlert('success',message,'alert_DeleteItem_Success');
            })
            .catch(error => {
                dispatch(deleteItemError(error));

                const message = `An error occurred trying to update the item `

                sweetAlert('error',message,'alert_DeleteItem_Error');
            })
    }
}

export function delItemByCommunity(id, objStyles) {
    return dispatch => {
        
        dispatch(deleteItem());
        
        fetch(API_URL+'items/delitemcommunity/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deleteItemSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The element has been deleted successfully`

                sweetAlert('success',message,'alert_DeleteItemByCommunity_Success', objStyles);
            })
            .catch(error => {
                dispatch(deleteItemError(error));

                const message = `An error occurred trying to update the item `

                sweetAlert('error',message,'alert_DeleteItemByCommunity_Error', objStyles);
            })
    }
}

//#endregion

//#region ITemsIcon


//#region ITEM (ALL - BYID)
export function getItemsIcons(data) {
    return {
        type: ITEMICON,
        data
    }
}

export function getItemsIconsSuccess(data) {
    return {
        type: ITEMICON_SUCCESS,
        data
    }
}

export function getItemsIconsError(data) {
    return {
        type: ITEMICON_ERROR,
        data
    }
}

export function getAllItemsIcons(data) {
    return dispatch => {
        dispatch(getItemsIcons());
        fetch(API_URL+'items/itemsIcon',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                 }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getItemsIconsSuccess(res));;
                return res;
            })
            .catch(error => {
                dispatch(getItemsIconsError(error));
            })
    }
}

function getItemDate(data) {
    return {
        type: ITEM_DATE,
        data
    }
}

function getItemDateSuccess(data) {
    return {
        type: ITEM_DATE_SUCCESS,
        data
    }
}

function getItemDateError(data) {
    return {
        type: ITEM_DATE_ERROR,
        data
    }
}

const getHeaders = (idCommunity, filters) => {
    const headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'CommunityId': idCommunity,

    }

    if (filters.dateOptionSelected) {
        headers.date_option = filters.dateOptionSelected

    } else if (filters.dateChanged && !filters.dateOptionSelected) {
        headers.start_date = filters.startDate
        headers.end_date = filters.endDate
    }

    return headers;

}

export function getItemsPerDates(communityId, options) {
    return async(dispatch) => {
        dispatch(getItemDate());

        const headers = getHeaders(communityId, options)

        const res = await fetch(API_URL+'items/itemsPerDate',{ method: 'GET', headers: headers });

        const body = await res.json();

        if(res.status===200){
            dispatch(getItemDateSuccess(body));
            return body;
        }else{
            dispatch(getItemDateError(body));

        }
    }
}

//#endregion